import { Suspense } from 'react';
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CensorProvider } from "./context/CensorContext";
import { SidebarProvider } from "./context/SidebarContext";
import { TimezoneProvider } from "./context/TimezoneContext";
import { AuthProvider } from "./context/AuthContext";

function PageLoader() {
  return (
    <div className="min-h-screen bg-surface flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-brand to-[#9884E8] flex items-center justify-center shadow-glow">
          <i className="ri-sparkling-2-fill text-white text-lg animate-pulse"></i>
        </div>
        <div className="flex items-center gap-2 text-gray-400">
          <div className="w-1 h-1 rounded-full bg-brand/40 animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-1 h-1 rounded-full bg-brand/40 animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-1 h-1 rounded-full bg-brand/40 animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <CensorProvider>
          <SidebarProvider>
            <TimezoneProvider>
              <BrowserRouter basename={__BASE_PATH__}>
                <Suspense fallback={<PageLoader />}>
                  <AppRoutes />
                </Suspense>
              </BrowserRouter>
            </TimezoneProvider>
          </SidebarProvider>
        </CensorProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
